var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyePublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7041 5.96179C17.0986 6.47778 17.0986 7.17436 16.7041 7.68952C15.4616 9.31155 12.4805 12.6513 9.00013 12.6513C5.51971 12.6513 2.53864 9.31155 1.29611 7.68952C1.10419 7.44245 1 7.13851 1 6.82566C1 6.5128 1.10419 6.20886 1.29611 5.96179C2.53864 4.33977 5.51971 1 9.00013 1C12.4805 1 15.4616 4.33977 16.7041 5.96179V5.96179Z",
    stroke: "#96A8C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00013 9.32228C10.379 9.32228 11.4968 8.20446 11.4968 6.82557C11.4968 5.44667 10.379 4.32886 9.00013 4.32886C7.62123 4.32886 6.50342 5.44667 6.50342 6.82557C6.50342 8.20446 7.62123 9.32228 9.00013 9.32228Z",
    stroke: "#96A8C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePublic);
export default __webpack_public_path__ + "static/media/eye-public.ae59a350d515d04dded6e7270bcc6444.svg";
export { ForwardRef as ReactComponent };